import './styles.css';

export default function InstructorAccountItemRadioButton({ 
  id,
  label,
  isChecked,
  onCheck,
  disabled,
  title
}) {
  return (
    <div 
      className={`account-item-radio ${disabled ? 'disabled' : ''}`}
      title={title ? title : ''}
    >
      <input 
        type="radio" 
        id={id} 
        checked={isChecked} 
        onChange={onCheck}
        disabled={disabled}
      />
      <label htmlFor={id}>{label.replace(/\s*\([^)]*\)/g, '')}</label>
    </div>
  );
}